import React from 'react'
import PropTypes from 'prop-types'
//components
import TitleMain from './titleMain';
import Button from './button';
//css
import '../assets/css/activation.css';
//store
import store from '../store/userStore';
//observer
import {observer} from 'mobx-react';
//axios
import axios from 'axios';
//config
import config from '../config';

@observer
class Activation extends React.Component {
  autoJumpEmail(){
    let username = store.username;
    let atPos = username.indexOf('@');
    let emailUrl = username.slice(atPos+1);
    if(emailUrl == 'qq.com'){
       emailUrl  = 'http://mail.qq.com'
    }else{
       emailUrl = `http://${emailUrl}`;
    }
    return emailUrl;
  }
  resend(){
    axios.get(`${config.server}/activate/resend`)
      .then(function(response){
        if(response.data == 'OK'){
          alert('郵件已發送');
        }
      })
      .catch(function(err){
        console.log(err);
      })
  }
  render () {
    return(
      <div>
        <TitleMain name='激活郵箱'/>
        <div className='Activation'>
          <div className='Activation__Desc'>
            <h1>請激活您的郵箱</h1>
          </div>
          <div className='Activation__active'>
            <a href={this.autoJumpEmail()} target='_blank'>
              <Button name='去激活' size='button--king'/>
            </a>
          </div>
          <p>*郵件有可能被標記為垃圾郵件</p>
          <div className='Activation__resend'>
            <p>沒收到郵件？ 點擊<span onClick={this.resend}style={{cursor:'pointer',textDecoration:'underline',color:'#7ECEFD'}}>重新發送</span></p>
          </div>
        </div>
      </div>
    )
  }
}

export default Activation;
